import { render, staticRenderFns } from "./TableTasksList.vue?vue&type=template&id=d3bede68"
import script from "./TableTasksList.vue?vue&type=script&lang=js"
export * from "./TableTasksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports